import { useEffect, useRef } from "react";

export const CandleCanvas = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const GAP = 26;
    const SPEED = 0.35;
    let raf;
    let w = 0;
    let h = 0;
    let candles = [];
    let lastClose = 0;

    const newCandle = (x) => {
      const drift = (Math.random() - 0.5) * h * 0.07;
      const open = lastClose;
      const close = Math.min(Math.max(open + drift, h * 0.15), h * 0.85);
      const high = Math.max(Math.min(open, close) - Math.random() * h * 0.04, 0);
      const low = Math.min(Math.max(open, close) + Math.random() * h * 0.04, h);
      lastClose = close;
      return { x, open, close, high, low };
    };

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      lastClose = h * 0.5;
      candles = [];
      for (let x = 0; x < w + GAP * 2; x += GAP) candles.push(newCandle(x));
    };

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = "rgba(94,162,255,0.05)";
      ctx.lineWidth = 1;
      for (let y = 0; y < h; y += 64) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(w, y);
        ctx.stroke();
      }
      for (let x = 0; x < w; x += 64) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, h);
        ctx.stroke();
      }

      candles.forEach((c) => {
        c.x -= SPEED;
        const up = c.close < c.open;
        ctx.strokeStyle = up ? "rgba(94,162,255,0.75)" : "rgba(47,125,246,0.2)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(c.x + 5, c.high);
        ctx.lineTo(c.x + 5, c.low);
        ctx.stroke();
        ctx.fillStyle = up ? "#2F7DF6" : "rgba(47,125,246,0.22)";
        const top = Math.min(c.open, c.close);
        const height = Math.max(Math.abs(c.close - c.open), 3);
        ctx.fillRect(c.x, top, 10, height);
      });

      while (candles.length && candles[0].x < -GAP) {
        candles.shift();
        candles.push(newCandle(candles[candles.length - 1].x + GAP));
      }
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
};
